'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Navigation = require('components/Navigation/Navigation');

var _Navigation2 = _interopRequireDefault(_Navigation);

var _Logo = require('components/Logo/Logo');

var _Logo2 = _interopRequireDefault(_Logo);

var _Footer = require('containers/Footer');

var _Footer2 = _interopRequireDefault(_Footer);

var _root = require('./root.css');

var _root2 = _interopRequireDefault(_root);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This is the main layout component
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var Root = function (_Component) {
  _inherits(Root, _Component);

  function Root() {
    _classCallCheck(this, Root);

    var _this = _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).call(this));

    _this.state = {
      loading: true
    };
    return _this;
  }

  _createClass(Root, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var cmsRequest = this.props.cmsRequest;

      cmsRequest();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ loading: false });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.props.loading !== newProps.loading) {
        this.setState({ loading: newProps.loading });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var location = this.props.location;
      var isHome = location.pathname === '/' || location.pathname === 'showreel' || false;
      var isContact = location.pathname === 'contact' || false;
      var workRegex = /\/?work\/?/;
      var isWork = workRegex.exec(location.pathname);
      var isDark = isWork !== null || isContact || false;

      var isLoading = this.state.loading;
      var overlayClass = isLoading ? _root2.default.overlay : _root2.default.overlayHidden;

      var path = this.props.location.pathname;
      var segment = path.split('/')[1] || 'root';

      return _react2.default.createElement(
        'div',
        { className: _root2.default.root },
        _react2.default.createElement(_Navigation2.default, { isHome: isHome, isDark: isDark }),
        _react2.default.createElement(
          'div',
          { ref: 'loader', className: overlayClass },
          _react2.default.createElement(
            'div',
            { className: _root2.default.overlayLoading },
            _react2.default.createElement(_Logo2.default, { isDark: false, isLoading: true })
          )
        ),
        _react2.default.cloneElement(this.props.children, { key: segment }),
        !isHome && _react2.default.createElement(_Footer2.default, null)
      );
    }
  }]);

  return Root;
}(_react.Component);

Root.propTypes = {
  children: _react.PropTypes.object.isRequired
};

exports.default = Root;


//////////////////
// WEBPACK FOOTER
// ./src/components/Root/Root.js
// module id = 334
// module chunks = 1